import { render, staticRenderFns } from "./AdsOverview.vue?vue&type=template&id=b267d87e&"
import script from "./AdsOverview.vue?vue&type=script&lang=js&"
export * from "./AdsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports